// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

import * as types from './actionTypes';

export function startLoader() {
  return {
    type: types.VOUCHER_DETAILS_START_LOADER
  };
}

export function stopLoader() {
  return {
    type: types.VOUCHER_DETAILS_STOP_LOADER
  };
}

export function getVoucher(payload) {
  return {
    type: types.VOUCHER_DETAILS_GET_VOUCHER,
    payload
  };
}

export function getVouchersSuccess(payload) {
  return {
    type: types.VOUCHER_DETAILS_GET_VOUCHER_SUCCESS,
    payload
  };
}
